import { BuiltinInstanceMemberValue } from './BuiltinInstanceMemberValue';
export class BuiltinSlotInstanceMemberValue extends BuiltinInstanceMemberValue {
    constructor(type, slot) {
        super();
        this.type = type;
        this.slot = slot;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.unwrapVal({ type: this.type }));
        sb.emitPushInt(node, this.slot);
        sb.emitOp(node, 'PICKITEM');
    }
}

//# sourceMappingURL=BuiltinSlotInstanceMemberValue.js.map
